import { Widget } from "fmko-ts-common";
import { CertTestCaseVO, CertTestVO } from "./RestTypes";
import CertTestService from "./CertTestService";
import CertTestAdminApp from "./CertTestAdminApp";

export default class IgnoreTestCaseWidget extends Widget {
    testCase: CertTestCaseVO;

    constructor(test: CertTestVO, testCase: CertTestCaseVO) {
        super();

        this.testCase = testCase;

        let input = <HTMLTextAreaElement>document.createElement("textarea");
        input.rows = 5;
        input.value = testCase.ignoreReason;

        let checkbox = <HTMLInputElement>document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.className = "checkbox-inline";
        checkbox.checked = testCase.ignored;

        input.addEventListener("keyup", (ev: KeyboardEvent) => {
            if (ev.keyCode === 13 || ev.which === 13) {
                // Return key
                CertTestService.getInstance().ignoreTestCase(test.name, testCase.testID, "ignore", input.value).then((tc) => {
                    CertTestAdminApp.certTestPanel.reload().then(() => {
                        CertTestAdminApp.certTestPanel.focusTestCase(this.testCase.testID);
                    });
                }).catch(err => CertTestAdminApp.alert("Ignorer fejlede", err.message));
            }
        });

        checkbox.addEventListener("click", (ev: MouseEvent) => {
            if (checkbox.checked !== testCase.ignored) {
                CertTestService.getInstance().ignoreTestCase(test.name, testCase.testID, checkbox.checked ? "ignore" : "unignore", input.value).then((tc) => {
                    CertTestAdminApp.certTestPanel.reload().then(() => {
                        CertTestAdminApp.certTestPanel.focusTestCase(this.testCase.testID);
                    });
                }).catch(err => CertTestAdminApp.alert("Ignorer fejlede", err.message));
            }
        });

        let div = document.createElement("div");
        div.appendChild(input);
        div.appendChild(checkbox);
        this.element = div;

    }
}
